import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { IButton } from '../_shared/models/button/button.model';
import { IMediaItem } from '../_shared/models/media/media-item.model';
import { VideoItemComponent } from '../media/media-item/video-item/video-item.component';
import { GridComponent } from '../grid/grid.component';
import { HeadingComponent } from '../heading/heading.component';
import { ButtonComponent } from '../button/button.component';

import { CastPipe } from '../_shared/pipes/cast.pipe';
import { LinkDirective } from '../_shared/directives/link.directive';

@Component({
    selector: 'sirius-hero-old',
    templateUrl: './hero-old.component.html',
    styleUrls: ['./hero-old.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
    VideoItemComponent,
    GridComponent,
    HeadingComponent,
    ButtonComponent,
    CastPipe,
    LinkDirective
]
})
export class HeroOldComponent {
    @Input() layout = 'textRight';
    @Input() mediaItem: IMediaItem = {
        type: 'image',
        title: '',
    };
    @Input() title = '';
    @Input() subtitle?: string;
    @Input() textHtml?: string;
    @Input() button?: IButton;

    sizes: string[][] = [];

    @HostBinding('class.sir-text-left') get textLeft() {
        return this.layout === 'textLeft';
    }

    @HostBinding('class.sir-text-right') get textRight() {
        return this.layout === 'textRight';
    }

    constructor() {
        // const sizes: string[][][] = ImageDataDb.hero['hero'];
        // this.sizes = sizes[0];
    }

    hasContent(): boolean {
        return this.textHtml || this.title || this.subtitle ? true : false;
    }
}
